import {Space} from 'antd';
import {
  TwitterShareButton,
  TwitterIcon,
  FacebookShareButton,
  FacebookIcon,
  TelegramShareButton,
  TelegramIcon,
} from 'react-share';

export default function SocialShare(props: {text: string; path?: string}) {
  const url = props.path ? window.location.origin + props.path : window.location.href;
  const {text} = props;

  return (
    <Space style={{marginTop: 50}}>
      <FacebookShareButton url={url} quote={text} hashtag='nft'>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={text} hashtags={['nft', 'lisamona']}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <TelegramShareButton url={url} title={text}>
        <TelegramIcon size={32} round />
      </TelegramShareButton>
    </Space>
  );
}
